import {
  Children,
  cloneElement,
  ComponentProps,
  isValidElement,
  ReactElement,
  ReactNode,
  useContext,
} from 'react';

import { mergeClasses } from '@/utils';

import { Checkbox } from '@/components/common';

import { TABLE_HEADER_VARIANTS } from './Table.constants';
import TableContext from './TableContext';
import TableHead from './TableHead';

const TableHeader = ({ className, children, ...props }: ComponentProps<'thead'>) => {
  const { size, hasCheckBox, checkboxState, onSelectAll } = useContext(TableContext);

  return (
    <thead
      data-slot="table-header"
      className={mergeClasses('', TABLE_HEADER_VARIANTS({ size: size }), className)}
      {...props}
    >
      {Children.map(children, (child) => {
        if (isValidElement(child) && hasCheckBox) {
          return cloneElement(child as ReactElement<ComponentProps<'tr'>>, {
            children: (
              <>
                <TableHead className="w-[72px] [&>*]:align-middle">
                  <Checkbox
                    checked={
                      checkboxState?.isIndeterminate
                        ? 'indeterminate'
                        : checkboxState?.isAllSelected
                    }
                    onClick={onSelectAll}
                    className="size-6"
                  />
                </TableHead>
                {(child as ReactElement<{ children?: ReactNode }>).props.children}
              </>
            ),
          });
        }
        return child;
      })}
    </thead>
  );
};

export default TableHeader;
